// App

// Constellation
import { Button, Trigger } from '@zillow/constellation';

// Actions
import { useAppSelector } from '../flux/configureStore';

// Components
import FilterTray from '../Filters/FilterTray';
import FilterModal from '../Filters/FilterModal';

// Misc / Utils
import { getFilterLabels } from '../utils/filterUtils';

interface FilterModuleProps {
  setIsLoading: (isLoading: boolean) => void;
}

const FilterModule = ({ setIsLoading }: FilterModuleProps) => {
  const isMobile = useAppSelector((state) => state.app.device.isMobile);
  const isMdScreen = useAppSelector((state) => state.app.device.screenWidth) === 'md';
  const isMobileOrTablet = isMobile || isMdScreen;
  const filter = useAppSelector((state) => state.filter);
  const {
    allFiltersLabel,
    activeRentalsLabel,
    offMarketLabel,
    bedroomsLabel,
    propertyTypesLabel,
    distanceLabel,
    amenitiesLabel,
  } = getFilterLabels(filter);

  // props are supplied from Trigger's triggered
  const allFiltersModal = (props: any, close: () => void) => (
    <FilterModal {...props} close={close} setIsLoading={setIsLoading} />
  );

  return isMobileOrTablet ? (
    // @ts-ignore triggered={allFiltersModal}
    <Trigger triggered={allFiltersModal}>
      <Button buttonType="secondary" fluid style={{ width: '220px' }}>
        {allFiltersLabel}
      </Button>
    </Trigger>
  ) : (
    <FilterTray
      activeRentalsLabel={activeRentalsLabel}
      offMarketLabel={offMarketLabel}
      bedroomsLabel={bedroomsLabel}
      propertyTypesLabel={propertyTypesLabel}
      distanceLabel={distanceLabel}
      amenitiesLabel={amenitiesLabel}
      setIsLoading={setIsLoading}
    />
  );
};

export default FilterModule;
